import {
  tickets,
  openId,
  bcLocation,
  cityId,
  areaId,
  companyId,
  cmsPreviewKey,
  passportId,
  userCode,
  updateBCLocation,
  companyToken,
  deviceToken
} from '@/defines/user'
import {
  browserEnv,
  platform,
  appInfo,
  deviceId,
  appVersion,
  miniProgramEnv,
  thirdSource,
  appKey
} from '@/defines/environment'
import { getGeoLocationCached } from '@/utils/geo_location'
import {
  isMallIOS,
  isMCMallCirculationIOS,
  isMCMallKeyCustomerIOS,
  isMallAndroid,
  isMCMallCirculationAndroid,
  isMCMallKeyCustomerAndroid
} from '@mc/mc-base-env/src/web/platform'
import Url from '@mc/mc-utils/js/url/url'

const { lat, lng } = getGeoLocationCached()

const openChannel = (() => {
  const url = new Url(window.location.href)
  // eslint-disable-next-line camelcase
  const { open_channel } = url.parseQuerystring()
  // eslint-disable-next-line camelcase
  return open_channel
})()

const system = (() => {
  const url = new Url(window.location.href)
  // eslint-disable-next-line camelcase
  const { system } = url.parseQuerystring()
  const _system = url?.Hash?.parseQuerystring()?.system
  // eslint-disable-next-line camelcase
  return system || _system
})()

const mallType = (() => {
  const url = new Url(window.location.href)
  const query = url.parseQuerystring()
  const hashQuery = url?.Hash?.parseQuerystring() || {}
  const value = query.mallType || hashQuery.mallType
  return Number(value) === 4 ? 4 : undefined
})()

const {
  // eslint-disable-next-line camelcase
  os_version = '',
  // eslint-disable-next-line camelcase
  appkey_version = '',
  // eslint-disable-next-line camelcase
  device_name = ''
} = appInfo

export const getSource = () => {
  const ua = navigator.userAgent.toLowerCase()
  switch (true) {
    case isMallIOS() || isMCMallCirculationIOS() || isMCMallKeyCustomerIOS():
      return 'ios'
    case isMallAndroid() ||
      isMCMallCirculationAndroid() ||
      isMCMallKeyCustomerAndroid():
      return 'android'
    case miniProgramEnv.isWechatMiniProgram:
      return 'mp'
    case miniProgramEnv.isAlipayMiniProgram:
      return 'alimp'
    case window.matrix.isMallHarmonyApp:
      return 'harmony'
    case ua.match(/swan/i)?.[0] === 'swan':
      return 'baidump'
    case (ua.match(/Toutiao/i)?.[0] === 'toutiao' &&
      ua.match(/NewsArticle/i)?.[0] === 'newsarticle') ||
      ua.match(/news_article_lite/i)?.[0] === 'news_article_lite':
      return 'toutiaomp'
    case ua.match(/Toutiao/i)?.[0] === 'toutiao':
      return 'douyinmp'
    case ua.match(/MicroMessenger/i)?.[0] === 'micromessenger':
      return 'weixin'
    default:
      return 'web'
  }
}

export const getRequestCommonParams = () => {
  const params = {
    tickets,
    _ENV_: {
      distribute_channel: browserEnv,
      platform,
      os_version,
      appkey_version,
      lat,
      lng,
      open_id: openId || '',
      device_id: deviceId,
      location: bcLocation || updateBCLocation(),
      openChannel: openChannel || '',
      device_name,
      source: getSource(),
      isH5: 1,
      latestH5: 2,
      app_version: appVersion,
      third_source: thirdSource.thirdSource,
      third_source_content: thirdSource.thirdSourceContent,
      app_key: appKey
    },
    city_id: cityId,
    area_id: areaId,
    company_id: companyId
  }
  if (mallType === 4) {
    params._ENV_.mallType = mallType
  }
  const isMallKeyCustomerApp =
    isMCMallKeyCustomerAndroid() || isMCMallKeyCustomerIOS()
  if (isMallKeyCustomerApp) {
    Object.assign(params, {
      channel: 1,
      platform: 1,
      from_mall: 'big_mall'
    })
  }
  if (cmsPreviewKey) {
    Object.assign(params._ENV_, {
      passport_id: passportId
    })
    Object.assign(params, {
      cms_preview_key: cmsPreviewKey
    })
  }
  if (userCode) {
    Object.assign(params, {
      user_code: userCode
    })
  }
  if (window.matrix.baseParams.previewToken) {
    Object.assign(params, {
      preview_token: decodeURIComponent(window.matrix.baseParams.previewToken)
    })
  }
  Object.assign(params, {
    system: system || 'mall'
  })
  return params
}

export const getRequestHeaderInfo = () => {
  return {
    companyToken,
    deviceToken
  }
}

export const MALL_STR = 'MEICAIMALL2022'

export const MALL_NEW_STR = 'MEICAIMALL2026'
